import * as types from './types'
import { GET_CALCULATOR_RESET } from './types'

export const actions = {
	getDataAction: (payload) => ({
		type: types.GET_DATA,
	}),

	getDataActionDone: (payload) => ({
		type: types.GET_DATA_DONE,
		payload,
	}),

	getDataActionFail: (payload) => ({
		type: types.GET_DATA_FAIL,
	}),


	getCalculatorAction: (payload) => ({
		type: types.GET_CALCULATOR,
		payload
	}),

	getCalculatorActionDone: (payload) => ({
		type: types.GET_CALCULATOR_DONE,
		payload,
	}),

	getCalculatorActionFail: (payload) => ({
		type: types.GET_CALCULATOR_FAIL,
	}),

	getCalculatorActionReset: (payload) => ({
		type: types.GET_CALCULATOR_RESET,
		payload
	}),


	getCropRaiAction: (payload) => ({
		type: types.GET_CROP_RAI,
	}),

	getCropRaiActionDone: (payload) => ({
		type: types.GET_CROP_RAI_DONE,
		payload,
	}),

	getCropRaiActionFail: (payload) => ({
		type: types.GET_CROP_RAI_FAIL,
	}),


	getCropRegionAction: (payload) => ({
		type: types.GET_CROP_REGION,
	}),

	getCropRegionActionDone: (payload) => ({
		type: types.GET_CROP_REGION_DONE,
		payload,
	}),

	getCropRegionActionFail: (payload) => ({
		type: types.GET_CROP_REGION_FAIL,
	}),
}
